import TableEditableComponent from 'components/elements/table/table';
import { ColumnDataType } from 'components/elements/table/type';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

export default function VisaDetailTable(props: { detail: any }) {
  const { t } = useTranslation();
  const columns = [
    {
      header: t('common:visa'),
      accessorKey: 'label',
      minSize: 100,
      dataType: ColumnDataType.text,
    },
    {
      header: t('document:biometric'),
      accessorKey: 'biometric',
      minSize: 100,
      dataType: ColumnDataType.checkbox,
    },
    {
      header: t('document:appointment_date'),
      accessorKey: 'appointmentAt',
      minSize: 100,
      dataType: ColumnDataType.date,
    },
    {
      header: t('document:appointment_time'),
      accessorKey: 'appointmentAt',
      minSize: 20,
      dataType: ColumnDataType.time,
    },
    {
      header: t('common:description'),
      accessorKey: 'description',
      minSize: 300,
      dataType: ColumnDataType.text,
    },
    {
      header: t('common:price'),
      accessorKey: 'price',
      minSize: 100,
      dataType: ColumnDataType.number,
      minNumber: 0,
    },
  ];

  return (
    <div style={{ width: '100%' }}>
      <TableEditableComponent
        columns={columns}
        data={[props.detail]}
        dispatch={() => {}}
        disabled
      />
    </div>
  );
}
